<cdk-virtual-scroll-viewport
    class="agpr-virtualScroll"
    [itemSize]="vsItemSize"
    [minBufferPx]="vsMinBufferPx"
    [maxBufferPx]="vsMaxBufferPx"
>
    <table
        role="grid"
        class="agpr-table"
        [attr.aria-rowcount]="columns.length + 1"
    >
        <caption class="u-srOnly">
            {{ 'Common.table.arrowKeyNavigation' | localize }}
            {{ 'Common.table.sortDescription' | localize }}
        </caption>
        <thead
            #tableHeader
            *ngIf="showHeader"
            class="agpr-tableHead"
        >
            <tr aria-rowindex="1">
                <th
                    *ngFor="let column of columns; let first = first; let i = index"
                    role="columnheader"
                    id="{{id}}_tableHeader_{{i}}"
                    class="agpr-tableHead-cell {{ column.styleClass }}"
                    [ngClass]="{
                        'agpr-tableHead-cell--sortable': column.sortable
                    }"
                    [ngStyle]="{
                        'width.px': column.width,
                        'paddingLeft.px': column.headerPaddingLeft
                    }"
                    tabindex="0"
                    [attr.aria-sort]="currentSortColumn === column ? (currentSortAscending ? 'ascending' : 'descending') : null"
                    (keydown)="$event.stopPropagation()"
                    (keyup)="handleHeaderKeyboardNavigation($event, column, i)"
                >
                    <div
                        class="agpr-tableInput"
                    >
                        <ng-container *ngIf="enableSelectAll && first">
                            <agpr-checkbox
                                [id]="id + '_th_' + i + '_checkbox'"
                                class="agpr-table-checkbox agpr-table-cell--checkbox"
                                [binary]="true"
                                [initiallyFocusable]="false"
                                [(ngModel)]="selectAll"
                                (ngModelChange)="toggleSelectAll($event)"
                            ></agpr-checkbox>
                        </ng-container>
                            <!-- eslint-disable @angular-eslint/template/interactive-supports-focus -->
                            <span
                                class="agpr-tableHead-cellSpan"
                                (click)="toggleSort(column)"
                            >
                                {{ column.heading | localize }}
                                <span
                                    *ngIf="column.sortable"
                                    (click)="toggleSort(column)"
                                    role="img"
                                    class="agpr-table-sortToggle fa-solid"
                                    [ngClass]="{
                                        'fa-arrows-up-down': currentSortColumn !== column,
                                        'fa-arrow-up': currentSortColumn === column && currentSortAscending,
                                        'fa-arrow-down': currentSortColumn === column && !currentSortAscending
                                    }"
                                ></span>
                            </span>
                            <!-- eslint-disable @angular-eslint/template/interactive-supports-focus -->
                    </div>
                </th>
                <th
                    *ngIf="showDelete || showView"
                    id="{{id}}_tableActionHeader"
                    class="agpr-tableHead-cell"
                    tabindex="0"
                    (keyup)="handleHeaderKeyboardNavigation($event, 'actionHeader')"
                >
                    {{ 'action' | localize }}
                </th>
            </tr>
        </thead>
        <tbody *ngIf="sortedData.length === 0">
            <tr>
                <td
                    [attr.colspan]="columns.length"
                >
                    <agpr-message
                        [severity]="messageSeverity.noContent"
                    >{{ noContentMessage | localize }}</agpr-message>
                </td>
            </tr>
        </tbody>
        <tbody>
            <tr
                *cdkVirtualFor="let item of flattenedData; let i = index;"
                [ngClass]="{
                    'agpr-table-group-header': item.type === rowTypes.group,
                    'agpr-table-row': item.type === rowTypes.row,
                    'agpr-table-row--active': item.type === rowTypes.row && item.row === selectedRow,
                    'agpr-table-row--selectableRow': item.type === rowTypes.row && selectableRow,
                    'agpr-table-row--selected': item.type === rowTypes.row && item.row.selected,
                    'agpr-table-row--collapsed': item.type === rowTypes.row && !item.expanded,
                    'agpr-table-row--grouped': sortedData.length > 1 || showGroupHeaders
                }"
            >
                <ng-container [ngSwitch]="item.type">
                    <ng-container *ngSwitchCase="rowTypes.group">
                        <th
                            *ngIf="showGroupHeaders"
                            class="agpr-table-group-header-name"
                            [attr.colspan]="item.group.actions ? columns.length - 1 : columns.length"
                        >
                            <div
                                class="agpr-table-cellContainer"
                            >
                                <agpr-checkbox
                                    [id]="`${id}_checkbox_${i}`"
                                    class="agpr-table-checkbox"
                                    [binary]="true"
                                    [initiallyFocusable]="false"
                                    [partialSelected]="item.group.partiallySelected"
                                    [(ngModel)]="item.group.selected"
                                    (ngModelChange)="toggleGroupSelect(item.group)"
                                >
                                </agpr-checkbox>
                                <agpr-button
                                    [id]="`${id}_toggle_${i}`"
                                    class="agpr-table-group-toggle"
                                    [style]="buttonTypes.icon"
                                    [icon]="item.expanded ? 'fa-solid fa-angle-up' : 'fa-solid fa-angle-down'"
                                    [tooltip]="item.expanded ? 'Core.collapse' : 'Core.expand'"
                                    [initiallyFocusable]="false"
                                    (click)="toggleGroup(item)"
                                >
                                </agpr-button>
                                <ng-template [ngIf]="editingGroup === item.group">
                                    <agpr-text-input
                                        [id]="`${id}_input_${i}`"
                                        [(ngModel)]="item.group.name"
                                        (keydown)="saveGroupName($event, item.group)"
                                        (blur)="saveGroupName($event, item.group)"
                                        [maxLength]="groupNameMaxLength"
                                        [initialFocus]="true"
                                        [bottomMargin]="false"
                                        [selectOnEdit]="true"
                                        [ariaLabel]="'Group Name'"
                                    ></agpr-text-input>
                                </ng-template>
                                <ng-template [ngIf]="editingGroup !== item.group">
                                    <span
                                        class="agpr-table-group-name"
                                    >
                                        {{ item.group.name }}
                                    </span>
                                    @if (!item.group.editDisabled) {
                                        <agpr-button
                                            [id]="`${id}_edit_${i}`"
                                            class="agpr-tableInput-icon"
                                            [style]="buttonTypes.icon"
                                            icon="fa-regular fa-duotone fa-pen"
                                            [tooltip]="'rename'"
                                            [initiallyFocusable]="false"
                                            (click)="editGroupName(item.group)"
                                        ></agpr-button>
                                    }
                                </ng-template>
                            </div>
                        </th>
                        <th *ngIf="showGroupHeaders && item.group.actions" class="agpr-table-group-actions">
                            <div
                                [agprLoading]="item.group.loading"
                                [smallLoadingIndicator]="true"
                            >
                                <agpr-kebab-menu
                                    [id]="`${id}_actionsMenu_${i}`"
                                    class="agpr-table-group-actionsBtn"
                                    [data]="item.group"
                                    [options]="item.group.actions"
                                    parentBottomOffset="70"
                                    [initiallyFocusable]="false"
                                >
                                </agpr-kebab-menu>
                            </div>
                        </th>
                    </ng-container>
                    <ng-container *ngSwitchDefault>
                        <td
                            *ngFor="let column of columns; let j = index"
                            role="gridcell"
                            [id]="`${id}_tableDataCell_${i}_${j}`"
                            class="agpr-table-cell {{ column.cellStyleClass }}"
                            [ngSwitch]="column.type"
                            [ngStyle]="{
                                'width.px': column.width
                            }"
                            [pTooltip]="item.row[column.tooltipField]"
                            tooltipPosition="top"
                            [tooltipDisabled]="editingRow === item.row && editingColumn === column"
                            [attr.aria-describedby]="rowSelectedAriaLabel ? id + '_rowSelectedHiddenDescription' : null"
                            tabindex="-1"
                            (keydown)="$event.stopPropagation()"
                            (keyup)="handleDataCellKeyboardNavigation($event, i, j)"
                        >
                            <div
                                class="agpr-table-cellContainer"
                            >
                                <agpr-checkbox
                                    *ngSwitchCase="columnTypes.checkbox"
                                    [id]="id + '_' + i + '_' + j + '_checkbox'"
                                    class="agpr-table-checkbox"
                                    [ngClass]="{ 'agpr-table-cell--checkbox': column.type === columnTypes.checkbox }"
                                    [label]="item.row[column.labelField]"
                                    [binary]="true"
                                    [initiallyFocusable]="false"
                                    [(ngModel)]="item.row[column.field]"
                                    (ngModelChange)="saveGroupedCheckboxValue($event, column, item)"
                                ></agpr-checkbox>
                                <div
                                    *ngSwitchCase="columnTypes.text"
                                    class="agpr-tableInput"
                                >
                                    <ng-container *ngIf="column.selectable">
                                        <agpr-checkbox
                                            class="agpr-table-checkbox"
                                            [id]="id + '_' + i + '_' + j + '_checkbox'"
                                            [ngClass]="{ 'agpr-table-cell--checkbox': column.selectable }"
                                            [binary]="true"
                                            [initiallyFocusable]="false"
                                            [(ngModel)]="item.row[column.selectField]"
                                            (ngModelChange)="saveGroupedCheckboxValue($event, column, item)"
                                        ></agpr-checkbox>
                                    </ng-container>
                                    <ng-template [ngIf]="editingRow === item.row && editingColumn === column">
                                        <agpr-text-input
                                            [id]="`${id}_input_${i}_${j}`"
                                            [(ngModel)]="item.row[column.field]"
                                            (keydown)="saveOnEnter($event, column, item.row)"
                                            (blur)="saveValue(column, item.row)"
                                            [maxLength]="column.fieldMaxLength"
                                            [initialFocus]="true"
                                            [bottomMargin]="false"
                                            [selectOnEdit]="true"
                                            [ariaLabel]="column.heading"
                                        ></agpr-text-input>
                                    </ng-template>
                                    <ng-template [ngIf]="editingRow !== item.row || editingColumn !== column">
                                        <span
                                            class="agpr-tableInput-value"
                                            [ngClass]="{'agpr-tableInput-value--sortable': column.sortable}"
                                        >
                                            {{ item.row[column.field] }}
                                        </span>
                                        @if (!item.row.editDisabled) {
                                            <agpr-button
                                                [id]="`${id}_edit_${i}_${j}`"
                                                class="agpr-tableInput-icon"
                                                [style]="buttonTypes.icon"
                                                icon="fa-regular fa-duotone fa-pen"
                                                [tooltip]="'rename'"
                                                [initiallyFocusable]="false"
                                                (click)="editField(column, item.row, $event)"
                                            ></agpr-button>
                                        }
                                    </ng-template>
                                </div>
                                <div
                                    *ngSwitchCase="columnTypes.textarea"
                                    class="agpr-tableInput"
                                    [ngClass]="{ 'agpr-tableInput--withCustomTemplate': column.customTemplate }"
                                >
                                    <ng-container
                                        [ngTemplateOutlet]="column.customTemplate"
                                        [ngTemplateOutletContext]="{column:column, row:item.row}"
                                    ></ng-container>
                                    <ng-container>
                                        <ng-template [ngIf]="editingRow === item.row && editingColumn === column">
                                            <agpr-textarea-input
                                                [id]="`${id}_textArea_${i}_${j}`"
                                                [(ngModel)]="item.row[column.field]"
                                                (keypress)="saveOnEnter($event, column, item.row)"
                                                (blur)="saveValue(column, item.row)"
                                                [maxlength]="column.fieldMaxLength"
                                                [initialFocus]="true"
                                                [bottomMargin]="false"
                                                [ariaLabel]="column.heading"
                                            ></agpr-textarea-input>
                                        </ng-template>
                                        <ng-template [ngIf]="editingRow !== item.row || editingColumn !== column">
                                            <div class="agpr-tableInput-flexContainer">
                                                <span class="agpr-tableInput-textarea">
                                                    {{ item.row[column.field] }}
                                                </span>
                                                <agpr-button
                                                    [id]="`${id}_edit_${i}_${j}`"
                                                    class="agpr-tableInput-icon"
                                                    [style]="buttonTypes.icon"
                                                    icon="fa-regular fa-duotone fa-pen"
                                                    [initiallyFocusable]="false"
                                                    (click)="editField(column, item.row, $evemt)"
                                                ></agpr-button>
                                            </div>
                                        </ng-template>
                                    </ng-container>
                                </div>
                                <div
                                    *ngSwitchCase="columnTypes.linkList"
                                >
                                    <agpr-link-list
                                        *ngIf="item.row[column.field]; else noLinks"
                                        class="agpr-tableInput-value"
                                        [links]="item.row[column.field]"
                                        [itemsMessage]="column.message"
                                        [listAriaLabel]="column.listAriaLabel"
                                        [id]="id + '_' + i + '_' + j + '_linkList'"
                                    ></agpr-link-list>

                                    <ng-template #noLinks>
                                        <span class="agpr-tableInput-value--emptyLinks">
                                            --
                                        </span>
                                    </ng-template>
                                </div>
                                <div
                                    *ngSwitchCase="columnTypes.custom"
                                >
                                    <ng-container
                                        [ngTemplateOutlet]="column.customTemplate"
                                        [ngTemplateOutletContext]="{column:column, columnIndex:j, row:item.row, rowIndex:i, selectedRow:selectedRow}"
                                    ></ng-container>
                                </div>
                                <span
                                    *ngSwitchDefault
                                    [ngClass]="{'agpr-tableInput-value--sortable': column.sortable}"
                                >
                                    <ng-container
                                        *ngIf="item.row[column.field] else nullPlaceholder"
                                        [ngSwitch]="column.format"
                                    >
                                        <ng-container
                                            *ngSwitchCase="rowFormats.date"
                                        >
                                            {{ item.row[column.field] | changeTimeZone : userPreferences?.timeZone : defaultDateFormat }}
                                        </ng-container>
                                        <ng-container
                                            *ngSwitchDefault
                                        >
                                            {{ item.row[column.field] }}
                                        </ng-container>
                                    </ng-container>
                                    <ng-template #nullPlaceholder>
                                        {{ tablePlaceholders.NULL_PLACEHOLDER }}
                                    </ng-template>
                                </span>
                                <span
                                    *ngIf="column.showInfoCircle"
                                    role="img"
                                    class="fa-regular fa-circle-info agpr-table-infoCircle"
                                    [agprTooltip]="item.row.tooltipInfo"
                                    tooltipPosition="top"
                                    [initiallyFocusable]="false"
                                    (keyup)="handleDataCellKeyboardNavigation($event, i)"
                                ></span>
                            </div>
                        </td>
                        <td
                            *ngIf="showActionCell"
                            id="{{id}}_tableActionCell_{{i}}"
                            class="agpr-table-cell agpr-table-actions"
                            [style.width]="actionItemWidth"
                            tabindex="-1"
                        >
                            @if (showView) {
                                <agpr-button
                                    [id]="`${id}_view_${i}`"
                                    class="agpr-tableRow-action"
                                    [style]="buttonTypes.icon"
                                    icon="fa-regular fa-duotone fa-eye"
                                    [tooltip]="viewIconTooltip"
                                    [initiallyFocusable]="false"
                                    (keydown)="$event.stopPropagation()"
                                    (keyup)="handleActionCellKeyboardNavigation($event, i)"
                                    (click)="view(item.row)"
                                ></agpr-button>
                            }
                            @if (showDelete) {
                                <agpr-button
                                    [id]="`${id}_delete_${i}`"
                                    class="agpr-tableRow-action"
                                    [style]="buttonTypes.icon"
                                    icon="fa-regular fa-duotone fa-trash-can"
                                    [tooltip]="deleteLabel"
                                    [initiallyFocusable]="false"
                                    (keydown)="$event.stopPropagation()"
                                    (keyup)="handleActionCellKeyboardNavigation($event, i)"
                                    (click)="deleteItem(item.row, i)"
                                ></agpr-button>
                            }
                        </td>
                    </ng-container>
                </ng-container>
            </tr>
        </tbody>
    </table>
    <span
        *ngIf="rowSelectedAriaLabel"
        [id]="id + '_rowSelectedHiddenDescription'"
        class="u-srOnly"
    >
        {{ rowSelectedAriaLabel | localize }}
    </span>
</cdk-virtual-scroll-viewport>
